function useUserPayrollPermission() {
  return {};
}

export default useUserPayrollPermission;
